import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionsGrid = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      id: 'friends',
      title: 'Friends',
      description: 'Connect with your cosmic circle',
      icon: 'Users',
      color: 'primary',
      count: 12,
      action: () => console.log('Navigate to friends')
    },
    {
      id: 'historical',
      title: 'Time Travel',
      description: 'Explore historical planetary tones',
      icon: 'History',
      color: 'secondary',
      count: null,
      action: () => navigate('/astrological-audio-player')
    },
    {
      id: 'profile',
      title: 'Profile',
      description: 'Manage your astrological data',
      icon: 'User',
      color: 'accent',
      count: null,
      action: () => console.log('Navigate to profile')
    },
    {
      id: 'compatibility',
      title: 'Compatibility',
      description: 'Compare tones with friends',
      icon: 'Heart',
      color: 'error',
      count: 3,
      action: () => console.log('Navigate to compatibility')
    }
  ];

  const getColorClasses = (color) => {
    switch (color) {
      case 'primary':
        return {
          bg: 'bg-primary/20',
          icon: '#4A5FBF',
          text: 'text-primary'
        };
      case 'secondary':
        return {
          bg: 'bg-secondary/20',
          icon: '#8B5CF6',
          text: 'text-secondary'
        };
      case 'accent':
        return {
          bg: 'bg-accent/20',
          icon: '#F59E0B',
          text: 'text-accent'
        };
      case 'error':
        return {
          bg: 'bg-error/20',
          icon: '#EF4444',
          text: 'text-error'
        };
      default:
        return {
          bg: 'bg-surface/50',
          icon: 'currentColor',
          text: 'text-text-primary'
        };
    }
  };

  return (
    <div className="glass bg-surface/50 backdrop-blur-cosmic rounded-2xl p-6 shadow-elevation-3">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-heading font-semibold text-text-primary">
            Quick Actions
          </h2>
          <p className="text-sm text-text-secondary mt-1">
            Navigate your cosmic journey
          </p>
        </div>
        <Button
          variant="ghost"
          iconName="MoreHorizontal"
          onClick={() => console.log('More actions')}
        />
      </div>

      {/* Actions Grid */}
      <div className="grid grid-cols-2 gap-4">
        {quickActions.map((action) => {
          const colors = getColorClasses(action.color);
          
          return (
            <div
              key={action.id}
              onClick={action.action}
              className="relative p-4 glass bg-surface/30 backdrop-blur-sm rounded-xl transition-cosmic hover:bg-surface/50 hover:scale-105 cursor-pointer group"
            >
              {/* Count Badge */}
              {action.count && (
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-primary text-primary-foreground text-xs font-bold rounded-full flex items-center justify-center animate-gentle-pulse">
                  {action.count}
                </div>
              )}

              {/* Icon */}
              <div className={`w-12 h-12 ${colors.bg} rounded-xl flex items-center justify-center mb-3 group-hover:scale-110 transition-cosmic`}>
                <Icon name={action.icon} size={24} color={colors.icon} />
              </div>

              {/* Content */}
              <div>
                <h3 className="text-sm font-heading font-medium text-text-primary mb-1">
                  {action.title}
                </h3>
                <p className="text-xs text-text-secondary">
                  {action.description}
                </p>
              </div>

              {/* Hover Effect */}
              <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-primary/5 to-secondary/5 opacity-0 group-hover:opacity-100 transition-cosmic"></div>
            </div>
          );
        })}
      </div>

      {/* Additional Actions */}
      <div className="mt-6 pt-4 border-t border-border/50">
        <div className="grid grid-cols-2 gap-3">
          <Button
            variant="outline"
            iconName="Download"
            onClick={() => console.log('Export data')}
            fullWidth
          >
            Export Data
          </Button>
          <Button
            variant="outline"
            iconName="Share"
            onClick={() => console.log('Share profile')}
            fullWidth
          >
            Share Profile
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickActionsGrid;